<template>
  <div class="hello">
    <h1>{{ msg }}</h1>

    <button v-if="user" @click="logout">Logout</button>
    <!-- <button v-if="!user" @click="login">Login</button> -->
    <button @click="loginGoogle">Login google</button>

    <router-link v-if="user" to="/safe">Safe</router-link>

  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'

export default {
  name: 'login',
  methods: {
    ...mapActions(['login', 'logout', 'loginGoogle'])
  },
  computed: {
    ...mapState(['user'])
  },
  data () {
    return {
      msg: 'Login Page~!'
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h1, h2 {
  font-weight: normal;
}

ul {
  list-style-type: none;
  padding: 0;
}

li {
  display: inline-block;
  margin: 0 10px;
}

a {
  color: #42b983;
}
</style>



// WEBPACK FOOTER //
// Login.vue?175b3be6